import {useEffect} from 'react'
import {createUseStyles} from 'react-jss'
import {AudienceModel, CreateOrUpdateAudienceModel} from '../../../redux/inAppMessageTypes'
import {Colors} from '../../../constants/colors'
import S2 from '../../typography/S2'

interface Props {
  audience: Extract<AudienceModel, { type: 'allUsers' }> | undefined
  onChange: (audience: Extract<CreateOrUpdateAudienceModel, { type: 'allUsers' }>) => void
}

const AllUsersAudienceEditor = ({audience, onChange}: Props) => {
  const styles = useStyles()

  useEffect(() => {
    // Always emit the "all users" audience when this editor is active
    onChange({type: 'allUsers'})
  }, [onChange])

  return (
    <div className={styles.container}>
      <S2 className={styles.hint}>
        This message will be displayed to all users of the application.
      </S2>
    </div>
  )
}

export default AllUsersAudienceEditor

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8
  },
  hint: {
    color: Colors.gray0,
  }
})
